export function convertStakedDays(stakedDays:number, stakedAmount:number) {
    return (stakedDays/ stakedAmount).toFixed();
}